import { useFeatureGate } from '@ctct/awesome-feature-flags';
import { envs, urlParams } from '@ctct/infrastructure-layer';

export const useIsRedirectFromSecureEnabled = () => {
  // In secure app, read from URL param (no Statsig access)
  if (envs.isSecure()) {
    const isRedirectFromSecureEnabledViaURLParam = urlParams.getIsRedirectFromSecureEnabled();

    return {
      data: isRedirectFromSecureEnabledViaURLParam,
      isLoading: false,
      isError: false,
      error: null,
    } as ReturnType<typeof useFeatureGate>;
  }

  // In billing app (non-secure), use Statsig only (ignore URL param)
  // hooks list will be stable per env, so we can safely disable the hooks rule
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useFeatureGate({
    name: 'enable_payflow_secure_domain_redirection_to_billing_app',
    defaultValue: false,
  });
};
